// app/components/chat/composer.tsx
import { useState } from 'react';
import { cn } from '~/lib/utils';

export function Composer({
  placeholder,
  onSend,
  allowEmpty = false,
  disabled = false,
}: {
  placeholder: string;
  onSend: (text: string) => void;
  allowEmpty?: boolean;
  disabled?: boolean;
}) {
  const [text, setText] = useState('');

  const submit = () => {
    const trimmed = text.trim();
    if (!allowEmpty && !trimmed) return;
    onSend(trimmed);
    setText('');
  };

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-full border-2 border-neutral-200 py-1.5 pl-4 pr-1.5 focus-within:border-neutral-900',
        disabled && 'opacity-50',
      )}
    >
      <input
        type="text"
        value={text}
        disabled={disabled}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            submit();
          }
        }}
        aria-label="Escribe un mensaje"
        placeholder={placeholder}
        maxLength={300}
        className="flex-1 bg-transparent text-sm text-neutral-900 outline-none placeholder:text-neutral-400"
      />
      <button
        type="button"
        aria-label="Enviar"
        disabled={disabled}
        onClick={submit}
        className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-neutral-900 text-white transition-colors hover:bg-neutral-700 disabled:bg-neutral-200"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M12 19V5M5 12l7-7 7 7" />
        </svg>
      </button>
    </div>
  );
}
